import React from "react";
import cn from "classnames";
import Select from "./Select";
import { TimeTypes } from "../../models/DateTime";
import "../../styles/ui/time-input.scss";

const timeOptions = minutes => Array.from({
  length: 24 * 60 / minutes
}, (v, i) => {
  let h = Math.floor(i * minutes / 60);
  let m = i * minutes - h * 60;

  if (m < 10) {
    m = "0" + m;
  }

  return h + ":" + m;
});

const timeSelectOptions = timeOptions(15).map(time => ({
  label: time,
  value: time
}));

const TimeInput = ({
  dateTime,
  onTimeChange,
  onTimeTypeChange,
  isReturn
}) => {
  const departingNowOption = isReturn ? [] : [{
    value: TimeTypes.DEPART_NOW,
    label: "Now"
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: cn("otrl-ui__time-input-container", {
      "otrl-ui__time-input-container--time-type": true //!dateTime.isDepartingNow()

    })
  }, /*#__PURE__*/React.createElement(Select, {
    name: "timeType",
    className: "otrl-ui__time-input",
    onChange: onTimeTypeChange,
    options: [{
      value: TimeTypes.LEAVING_AT,
      label: "Leaving at"
    }, {
      value: TimeTypes.ARRIVING_AT,
      label: "Arriving at"
    }],
    value: dateTime.getTimeType()
  }), /*#__PURE__*/React.createElement(Select, {
    name: "time",
    className: cn("otrl-ui__time-input", "otrl-ui__time-input--hour-minute") // disabled={isDepartingNow}
    ,
    onChange: onTimeChange,
    options: [...departingNowOption, ...timeSelectOptions],
    value: dateTime.isDepartingNow() ? "Depart now" : dateTime.getTimeString()
  }));
};

export default TimeInput;